/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 $(document).ready(function(){

  // Check apple device
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $("body").addClass("u-mac");
    }

    _iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
    if(_iOSDevice){
        $('.slider-dots-box button').addClass('ios');
    }
  // Check apple device
   
   // Height Slideshow 
    function heightSlideshow(){
       var $headerHeight = $('#shopify-section-header').outerHeight();
       if($(window).width() < 999){
            $('.shopify-section--slideshow').outerHeight($(window).height());
            $('.Slideshow__Slide').outerHeight($(window).height());
       }else{
            $('.shopify-section--slideshow').css('height', '100vh');
            $('.Slideshow__Slide').css('height', '100vh');
       }
   }
   heightSlideshow();
   $( window ).resize(function() {
     heightSlideshow();
   });
   // End Height Slideshow 

  
    // $('#shopify-section-header').prepend($("#shopify-section-announcement"));


  // Scroll Header Fix 

    headerFix();
    $(window).scroll(function(){
        headerFix();
        var winTop = $(window).scrollTop();
    });

    var temp = $(window).scrollTop();
    var headerHeight = $(window).innerHeight();

    $(window).resize(function(){
      headerHeight = $(window).innerHeight();
      // heightSlideshow();
    })
    

    function headerFix(){
        var $windowTop = $(window).scrollTop();
        var $header = $('#section-header');
        
        var $showMenu = $('.js-show-menu');
        var $trigger = $(window).height();
        if($showMenu.length){
          $trigger = $showMenu.offset().top - 75;
        }

        if($(window).width() > 768){
            if($windowTop > 200){
                $header.addClass('js-pre-header-fix');
            }else{
                $header.removeClass('js-pre-header-fix');
            }
            
            if($windowTop > 300){
                $header.addClass('js-pre-header-fix-2');
            }else{
                $header.removeClass('js-pre-header-fix-2');
            }
            
            if($windowTop > $trigger){
                $header.addClass('js-header-fix');
            }else{
                $header.removeClass('js-header-fix');
            }

        }else{
            if($windowTop > 200){
                $header.addClass('js-pre-header-fix');
                $('.page-container').addClass('js-sticky');
            }else{
                $header.removeClass('js-pre-header-fix');
                $('.page-container').removeClass('js-sticky');
            }
            
            if($windowTop > 280){
                $header.addClass('js-pre-header-fix-2');
            }else{
                $header.removeClass('js-pre-header-fix-2');
            }
            
            if($windowTop > $trigger){
                $header.addClass('js-header-fix');
            }else{
                $header.removeClass('js-header-fix');
            }
        }

        $(window).resize(function(){
          var $trigger = $(window).height();
          if($showMenu.length){
            $trigger = $showMenu.offset().top - 75;
          }

          if($(window).width() > 768){
            if($windowTop > 200){
                $header.addClass('js-pre-header-fix');
            }else{
                $header.removeClass('js-pre-header-fix');
            }
            
            if($windowTop > 300){
                $header.addClass('js-pre-header-fix-2');
            }else{
                $header.removeClass('js-pre-header-fix-2');
            }
            
            if($windowTop > $trigger){
                $header.addClass('js-header-fix');
            }else{
                $header.removeClass('js-header-fix');
            }

          }else{
              if($windowTop > 100){
                  $header.addClass('js-pre-header-fix');
                  $('.page-container').addClass('js-sticky');
              }else{
                  $header.removeClass('js-pre-header-fix');
                  $('.page-container').removeClass('js-sticky');
              }
              
              if($windowTop > 250){
                  $header.addClass('js-pre-header-fix-2');
              }else{
                  $header.removeClass('js-pre-header-fix-2');
              }
              
              if($windowTop > $trigger){
                  $header.addClass('js-header-fix');
              }else{
                  $header.removeClass('js-header-fix');
              }
          }
        })

        if($('.js-header-fix').length){
          $('.CollectionToolbar').addClass('CollectionToolbar__Sticky');
        }else{
          $('.CollectionToolbar').removeClass('CollectionToolbar__Sticky');
        }

        $(window).scroll(function(){
          if($('.js-header-fix').length){
            $('.CollectionToolbar').addClass('CollectionToolbar__Sticky');
          }else{
            $('.CollectionToolbar').removeClass('CollectionToolbar__Sticky');
          }
        })
    }

  // End Scroll Header Fix 

  $( window ).resize(function() {
    if($( window ).width() <= 999){
      var r = 8.665;
      var stroke = 1;
      var width = r * 2 + stroke;
      var anchor = width / 2;
      var rlen = 2 * Math.PI * r;
      var svg = $('.progress');
      var circle = $('.progress circle');
      svg.attr('width', width);
      svg.attr('height', width);
      circle.attr('r', r);
      circle.attr('cx', anchor);
      circle.attr('cy', anchor);
      circle.css('stroke-dasharray', rlen);
      circle.css('stroke-dashoffset', rlen);
    }else{
      var r = 12;
      var stroke = 1;
      var width = r * 2 + stroke;
      var anchor = width / 2;
      var rlen = 2 * Math.PI * r;
      var svg = $('.progress');
      var circle = $('.progress circle');
      svg.attr('width', width);
      svg.attr('height', width);
      circle.attr('r', r);
      circle.attr('cx', anchor);
      circle.attr('cy', anchor);
      circle.css('stroke-dasharray', rlen);
      circle.css('stroke-dashoffset', rlen);
    }
  });
     


  // Slideshow progress 

    $(".Slideshow__Carousel").on("init reInit afterChange beforeChange", function (
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var index = currentSlide ? currentSlide : 0;

    var autoplaySpeed = slick.slickGetOption("autoplaySpeed");
    var speed = slick.slickGetOption("speed");
    var controller = $(".slider-dots-box");
    var slider = $(".Slideshow__Slide");
    var r = 12;
    var stroke = 1;
    var width = r * 2 + stroke;
    var anchor = width / 2;
    var rlen = 2 * Math.PI * r;

    if($( window ).width() <= 999){
      r = 8.665;
      width = r * 2 + stroke;
      anchor = width / 2;
      rlen = 2 * Math.PI * r;
    }


    if (event.type == "init") {
      var current_html = "";
      for (let i = 1; i <= slick.slideCount; i++) {
        current_html += "<button>";
        current_html +=
          '<svg class="progress" width="' +
          width +
          '" height="' +
          width +
          '"><circle r="' +
          r +
          '" cx="' +
          anchor +
          '" cy="' +
          anchor +
          '" style="stroke-dasharray: ' +
          rlen +
          "px; stroke-dashoffset: " +
          rlen +
          "px; stroke-width: " +
          stroke +
          'px"/></svg>';
        current_html += "<span>" + i + "</span>";
        current_html += "</button>";
      }
      controller.html(current_html);
      controller.children().eq(index).find("circle").stop().animate(
        {
          "stroke-dashoffset": "0px"
        },
        autoplaySpeed
      );

      controller.find("button").each(function (item, index) {
        $(this).click(function () {
          slick.slickGoTo(item);
        });
      });
        var image = slider.eq(index).find(".Slideshow__Image");
      image.addClass("animate_scale");
    }
    if (event.type == "beforeChange") {
      var target = controller.children().eq(index).find("circle");
        slider.eq(nextSlide).find(".Slideshow__Image").addClass("animate_scale");
      target.css({
        "stroke-dashoffset": "0px"
      });
      target.stop().animate(
        {
          "stroke-dashoffset": -rlen + "px"
        },
        speed
      );
    }
    if (event.type == "afterChange") {
      var target = controller.children().eq(index).find("circle");
      var prevIndex = index - 1 < 0 ? slick.slideCount - 1 : index - 1;
      slider.eq(prevIndex).find(".Slideshow__Image").removeClass("animate_scale");
      target.css({
        "stroke-dashoffset": rlen + "px"
      });
      target.stop().animate(
        {
          "stroke-dashoffset": "0px"
        },
        autoplaySpeed
      );
    }
    });


    $('.Slideshow__Carousel').slick({
        arrows: false,
        infinite: true,
        dots: false,
        draggable: true,
        focusOnSelect: true,
        autoplay: true,
        autoplaySpeed:7000,
        pauseOnHover: false,
        pauseOnFocus: false,
        outerEdgeLimit: true,
        fade:true
    });

    $('.Slideshow__Carousel').on('touchstart', e => {
      $('.Slideshow__Carousel').slick('slickPlay');
    });

    $('.Slideshow__Carousel').on( 'touchend touchcancel touchmove', function() { $(this).slick('slickPlay'); } );

  // End Slideshow progress


  $('.AnnouncementBar__Wrapper').slick({
        arrows: false,
        infinite: true,
        dots: false,
        draggable: true,
        focusOnSelect: true,
        autoplay: true,
        autoplaySpeed:4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        outerEdgeLimit: true,
        fade:true
    });
  


  // var foreignCharacters = $(".SidebarMenu__Nav .Collapsible__Item").text();
  // var rforeign = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;


  
  // $(".SidebarMenu__Nav .Collapsible").each(function(){
  //   var $text = $(this).find('.Collapsible__Button').text();
  //   $(this).find('.Collapsible__Button').html('<p class="Collapsible__Item"></p>');
  //   var $box = $(this).find('p.Collapsible__Item');

  //   var $rforeign = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/;
  //   if ($rforeign.test($text)) {
  //     var $jpText = '<span class="Collapsible__ItemText Collapsible__ItemTextJp">'+ $text +'</span>';
  //     $box.append($jpText);
  //   }
  // })

  

  // if (!rforeign.test(foreignCharacters)) {
  //   var $engText = '<span class="Collapsible__ItemText Collapsible__ItemTextEng">'+ foreignCharacters +'</span>';
  //   $(".SidebarMenu__Nav .Collapsible__Item").html($engText);
  // }
  // if (rforeign.test(foreignCharacters)) {
  //   var $jpText = '<span class="Collapsible__ItemText Collapsible__ItemTextJp">'+ foreignCharacters +'</span>';
  //   $(".SidebarMenu__Nav .Collapsible__Item").append($jpText);
  // }


  // boost-pfs app 

    var checkSeachInput = setInterval(function() {
       var $item = $('.boost-pfs-search-box');
       if ($item.length) {
           clearInterval(checkSeachInput);

           $('.boost-pfs-search-box').attr("placeholder", "キーワード検索");
       }
    }, 100); // check every 100ms
    
    // Remove prefix tags
    if($(".template-collection,.template-search").length){
      var removePrefixTags = setInterval(function (){
        if($(".boost-pfs-filter-option-value").length){
          $(".boost-pfs-filter-option-value").each(function(index,val){
            var text = $(val).text().toLowerCase().trim();
            if(text.indexOf("limit:__") > -1){
              // $(val).parents(".boost-pfs-filter-option-item").remove();
              $(this).html(text.split('limit:__')[1]);
            }
            else if(text.indexOf("label__") > -1){
              // $(val).parents(".boost-pfs-filter-option-item").remove();
              $(this).html(text.split('label__')[1]);
            }
          });
        }
        if($(".boost-pfs-filter-option-price-¥ .boost-pfs-filter-option-title-text").length){
          $(".boost-pfs-filter-option-price-¥ .boost-pfs-filter-option-title-text").html('Price');
        }
        
        
      }, 200);
    }

    
      var checkfilterSP = setInterval(function() {
          var $item = $(".boost-pfs-filter-option-title");
          if ($item.length) {
              clearInterval(checkfilterSP);
              $('.boost-pfs-filter-option-title').click(function(){
                if($(window).width() <= 768){
                  
                }
                $(this).next().toggleClass("c-toggle-panel");
                  $(this).toggleClass("c-toggle-panel");
              })
              
              FilterApi.afterCall = function() {
                    setTimeout(function(){
          //           console.log($('.boost-pfs-filter-option-title'));
                          $('.boost-pfs-filter-option-title').off();
                          $('.boost-pfs-filter-option-title').click(function(){
          //                     console.log('clicked');
                            $(this).next().toggleClass("c-toggle-panel");
                            $(this).toggleClass("c-toggle-panel");
                          })
                    }, 0)
             }
          }
      }, 100); // check every 100ms
    


  // end boost-pfs app 


  // Slide Product 

    $('.c-featured-collections__slide').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        draggable: true,
        appendArrows: $('.c-featured-collections__arrow'),
        responsive: [
            {
                breakpoint: 999,
                settings: {
                arrows: true,
                variableWidth: true,
                outerEdgeLimit: true,
                slidesToShow: 1
                }
            }
        ]
    });

    // End Slide Product 
   
   // Slide Shop now

    $('.c-featured-collections__shop-now').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        draggable: true,
        appendArrows: $('.c-featured-collections__arrow'),
        responsive: [
            {
                breakpoint: 999,
                settings: {
                arrows: true,
                variableWidth: true,
                outerEdgeLimit: true,
                slidesToShow: 1
                }
            }
        ]
    });

    // End Slide Shop now


    // Slide Collection 

    $('.c-collection-list__slide').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        draggable: true,
        appendArrows: $('.c-collection-list__arrow'),
        responsive: [
            {
                breakpoint: 999,
                settings: {
                arrows: true,
                variableWidth: true,
                outerEdgeLimit: true,
                slidesToShow: 1
                }
            }
        ]
    });

    // End Slide Collection 


    // Close section news

    $('.c-news__close').click(function(){
      $('.shopify-section-c-news').remove();
    })

    // End Close section news 


    // Related product slider 
    if($('.template-product').length){
      var $item = $('.ProductRecommendations--carousel');

      if ($item.length) {
        $item.hide();
      }
      
      var checkRelatedProduct = setInterval(function() {
        if ($item.length) {
          clearInterval(checkRelatedProduct);
          ProductRecommendations();
          $item.show();
        }
      },2000); // check every 100ms
    }
    
    function ProductRecommendations(){
      $('.ProductRecommendations--carousel').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          dots: false,
          draggable: true,
          appendArrows: $('.ProductRecommendations__arrow'),
          responsive: [
              {
                  breakpoint: 999,
                  settings: {
                  arrows: true,
                  variableWidth: true,
                  outerEdgeLimit: true,
                  slidesToShow: 1
                  }
              }
          ]
      });
    }
    

    // End Related product slider 


    // Product Tabs 

    $('.Product__AccordionButton li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $('.Product__AccordionButton li').removeClass('current');
      $('.tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    })

    $('.sp .Product__AccordionButton').on('click',function(){
       $(this).next().slideToggle("slow");
       $(this).toggleClass("c-show");
    });

    // End Product Tabs 
//    setTimeout(function(){
//    	$('button.wk-button').remove();
//     }, 100);

   if(WishlistKing.toolkit.getProduct($('.btn-wishlist').data('product-id')) == null) {
          $('.btn-wishlist').addClass('remove-wk');
          $('.btn-wishlist').removeClass('add-wk');
        } else {
          
          $('.btn-wishlist').addClass('add-wk');
         $('.btn-wishlist').removeClass('remove-wk');
        }
      
      $('.btn-wishlist').click(function(){
        var $this = $(this);
        
//           console.log($(this).data('product-id'));
        if($this.hasClass('remove-wk')) {
//             console.log("Add wishlist");
          WishlistKing.toolkit.addProduct($this.data('product-id')).then(function(){
            $this.addClass('add-wk');
            $this.removeClass('remove-wk');
          });
          
        } else {
//             console.log("Remove wishlist");
          WishlistKing.toolkit.removeProduct($this.data('product-id')).then(function(){
            $this.addClass('remove-wk');
            $this.removeClass('add-wk');
          });
          
        }
          
        
//           WishlistKing.toolkit.addProduct($(this).data('product-id'));
//           .then(function(){
//             console.log('Product added to wishlist.');
//           })
//           .catch(console.error);
      })


    // Semi Order 
      
      
       function cloneCanvas(oldCanvas) {

          //create a new canvas
          var newCanvas = document.createElement('canvas');
          var context = newCanvas.getContext('2d');

          //set dimensions
          newCanvas.width = oldCanvas.width;
          newCanvas.height = oldCanvas.height;

          //apply the old canvas to the new one
          context.drawImage(oldCanvas, 0, 0);

          //return the new canvas
          return newCanvas;
        }

    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
      var changeAddToCartText = (function() {
            if( $('.cpb-add-to-cart-button span').length) {
              $('.cpb-add-to-cart-button span').text('カートに追加する');
            } else {
              window.requestAnimationFrame(changeAddToCartText);
            }   
      });
      changeAddToCartText();

      $('body').removeClass('template-cpb-product');

      var $price = $('.cpb-product-price').html();
    //    var $metefield_info_lead = $('.Product_metafield').html();
    //   $('.cpb-product-description').html($metefield_info_lead+"<div class='ProductItem__PriceBox'><span class='ProductItem__Price Price'>"+$price+"</span>" + "<span class='c-tax'>(税込)</span></div>");
//         $('.Product_metafield').remove();
      
//         var $getbtnwishlist = $('.getbtnwishlist').html();
//         $('.cpb-product-actions-container').append($getbtnwishlist);
//         $('.getbtnwishlist').remove();
     $('.cpb-product-actions-container').append($('.getbtnwishlist')); 
      $('.ProductMeta__Description').insertAfter($('.cpb-product-title')); 
    //   $('.cpb-panels-tabs-wrapper').prepend("<div class='ProductMeta__PriceList Heading'><span class='ProductMeta__Price Price Text--subdued u-h4'>"+$price+"</span>" + "<span class='c-tax'>(税込)</span></div>");
      
    $('.ProductMeta__PriceList').insertBefore($('.cpb-panels-tabs-wrapper')); 
//         if(WishlistKing.toolkit.getProduct($('.btn-wishlist').data('product-id')) == null) {
//             $('.btn-wishlist').addClass('remove-wk');
//             $('.btn-wishlist').removeClass('add-wk');
//           } else {
         
//              $('.btn-wishlist').addClass('add-wk');
//            $('.btn-wishlist').removeClass('remove-wk');
//           }
      
//         $('.btn-wishlist').click(function(){
//           var $this = $(this);
        
// //           console.log($(this).data('product-id'));
//           if($this.hasClass('remove-wk')) {
// //             console.log("Add wishlist");
//             WishlistKing.toolkit.addProduct($this.data('product-id')).then(function(){
//             	$this.addClass('add-wk');
//             	$this.removeClass('remove-wk');
//             });
          
//           } else {
// //             console.log("Remove wishlist");
//           	WishlistKing.toolkit.removeProduct($this.data('product-id')).then(function(){
//             	$this.addClass('remove-wk');
//             	$this.removeClass('add-wk');
//             });
          
//           }
          
        
// //           WishlistKing.toolkit.addProduct($(this).data('product-id'));
// //           .then(function(){
// //             console.log('Product added to wishlist.');
// //           })
// //           .catch(console.error);
//         })
      
      
      if($(window).width() < 1000){
        setTimeout(function(){
          $('<div class="image_clone"></div>').insertBefore('.cpb-product-actions')
          $('.image_clone').html(cloneCanvas($('.swiper-slide-active canvas[data-category="base"]')[0]));
        }, 1000);
//           $('.option').on('click',function(){
//             setTimeout(function(){
//               $('.image_clone').empty();
//               $('.swiper-slide-active canvas').each(function(){
//                 $('.image_clone').append(cloneCanvas($(this)[0]));
//               });
//             }, 800);
//           });
      }
      
      var $productTabs = $('.Product__Accordion').html();
      $('.cpb-panels-container.col-tabs').append("<div class='Product__Accordion Product__Accordion--Afterload'>"+$productTabs+"</div>");
      $('.Product__AccordionBeforeLoad').remove();

      $('.Product__AccordionButton li').click(function(){
        var tab_id = $(this).attr('data-tab');

        $('.Product__AccordionButton li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#"+tab_id).addClass('current');
      })

      $('.sp .Product__AccordionButton').on('click',function(){
        $(this).next().slideToggle("slow");
        $(this).toggleClass("c-show");
      });

      
      var $shareButton = $('.ProductMeta__ShareButtons').html();
      $('.cpb-panels-container.col-tabs').append("<div class='ProductMeta__ShareButtons ProductMeta__ShareButtons--Afterload'>"+$shareButton+"</div>");


      const swiper = document.querySelector('.cpb-swiper-main .swiper-container').swiper;
      swiper.allowTouchMove = true;
      swiper.params.touchRatio = 1;
      setTimeout(function() {
          $('.cpb-swiper-thumbnails .swiper-slide-active').trigger('click')
      },1000)
      console.log(swiper);
      
      $('.semi_order').removeClass('semi_order');
      
    })

    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {
      
      
      $('span.option.option-type-color').click(function(){
        $('.ProductItem__PriceBox').remove();
        var $price = $('.cpb-product-price').html();
        $('.cpb-product-description').append("<div class='ProductItem__PriceBox'><span class='ProductItem__Price Price'>"+$price+"</span>" + "<span class='c-tax'>(税込)</span></div>");
      
//           $('.image_clone').empty();
//           $('.swiper-slide-active canvas').each(function(){
//             $('.image_clone').append(cloneCanvas($(this)[0]));
//           });
      
      });
//         console.log(event);
      setTimeout(function() {
        $('.image_clone').empty();
        $('.swiper-slide-active canvas').each(function(){
          $('.image_clone').append(cloneCanvas($(this)[0]));
        });
      },1500)
    })
    
//       document.body.addEventListener('LAYER_IMAGE_UPDATE', function(event) {
//         console.log(2222);
//       })

    document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function(event) {
      $('span.option.option-type-color').click(function(){
        $('.ProductItem__PriceBox').remove();
        var $price = $('.cpb-product-price').html();
        $('.cpb-product-description').append("<div class='ProductItem__PriceBox'><span class='ProductItem__Price Price'>"+$price+"</span>" + "<span class='c-tax'>(税込)</span></div>");
      });
    })

    // End Semi Order 


    
    /* for desktop view */

 
  window.onload = function() {            
      function foo() {
          $('.shopify-payment-button__button--unbranded').text('今すぐ購入する');
      }
      setInterval(foo, 100);
  }
 

  //   $( ".Collapsible__List" ).each(function() {
  //     console.log( $( this + ".Collapsible__Button" ).text() );
  //   });

//     var data =$('#date').text();
// var arr = data.split('/');
// $("#date").html("<span>"+arr[0] + "</span></br>" + arr[1]+"/"+arr[2]);	 

    $('#Collapsible__List01 .Collapsible, #Collapsible__List02 .Collapsible').each(function() {
      // console.log($(this).find('.Collapsible__Button').text());
      var button = $(this).find('.Collapsible__Button');
      var data1 = $(button).text();
      var arr1 = data1.split('/');
      // console.log(data1)
      // console.log(arr1)
      $(button).html(
          '<p class="Collapsible__Item"><span class="Collapsible__ItemText Collapsible__ItemTextEng">'+ arr1[0] +'</span><span class="Collapsible__ItemText Collapsible__ItemTextJp">'+ arr1[1] +'</span></p>'
      );
   });
 
//    	$('#wk-trigger').on('click', function(){
//       $('.wk-button').trigger('click');
//   });
   
   if($('.ShopTheLook').length) {
     $(window).resize(function() {
       var fkty1 = Flickity.data('.ShopTheLook');
       var fkty2 = Flickity.data('.ShopTheLook__ProductList__PC');
       if(fkty1) {
       		fkty1.reloadCells()
       }
       if(fkty2) {
       		fkty2.reloadCells()
       }
     })
   }
 })